import { Toggle } from "@sede-enterprise/shell-ds-react-framework"
import { ToggleButton, ToggleButtonDiv } from "../charts/OverallPortfolioChart/index.styles"
import { ToggleText } from "../ScenerioModelling/ScenerioModelling.styles"

const VolumeEmissionToggle = (props: {isToggleOn: () => void}) => {
    return (
        <ToggleButtonDiv>
            <ToggleButton>
                <Toggle
                    label='Volume'
                    mirrored
                    data-testid='toggleButton'
                    onChange={() => props.isToggleOn()}
                />
            </ToggleButton>
            <ToggleText>Emissions</ToggleText>
        </ToggleButtonDiv>
    )
}

export default VolumeEmissionToggle;